var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgActionPending(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7 7.99483H6.17647C4.67907 7.99483 3.93037 7.99483 3.46518 7.55587C3 7.11691 3 6.41041 3 4.99742C3 3.58443 3 2.87793 3.46518 2.43896C3.93037 2 4.67907 2 6.17647 2H17.8235C19.3209 2 20.0696 2 20.5348 2.43896C21 2.87793 21 3.58443 21 4.99742C21 6.41041 21 7.11691 20.5348 7.55587C20.0696 7.99483 19.3209 7.99483 17.8235 7.99483H16.5",
    stroke: "#141B34",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.0296 21.9933C17.9799 20.2795 18.1199 20.0539 18.2514 19.6726C18.3828 19.2913 19.1984 17.9377 19.5236 16.9554C20.576 13.7772 19.7712 13.2398 18.5104 12.2743C17.0658 11.1681 14.6208 10.6052 13.0946 10.7268V6.63663C13.0946 5.77403 12.2692 5.02344 11.3432 5.02344C10.4172 5.02344 9.59704 5.77403 9.59704 6.63663V14.3886L7.62568 12.7112C7.0938 12.1738 6.24275 12.223 5.62664 12.6297C5.43494 12.7563 5.27952 12.9339 5.18075 13.1413C4.90045 13.7299 4.98135 14.3962 5.42292 14.9416L6.54372 16.3863M6.54372 16.3863C6.81124 16.71 7.08118 17.0876 7.42153 17.518M6.54372 16.3863L7.42153 17.518M9.52799 21.9992V21.0526C9.60063 19.8903 8.54484 18.9568 7.42153 17.518M7.42153 17.518C7.34059 17.4143 7.49821 17.615 7.42153 17.518ZM7.42153 17.518L8.52852 18.8718",
    stroke: "#141B34",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgActionPending);
export default __webpack_public_path__ + "static/media/action-pending.684de017f63e9032f134ef3c659bbe3d.svg";
export { ForwardRef as ReactComponent };